var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"justify-center",attrs:{"color":"#292929","height":"85"}},[_c('div',{staticClass:"subtitle-2 font-weight-light grey--text text--lighten-1 text-center"},[_vm._v(" © "+_vm._s((new Date()).getFullYear())+" — Cognizance ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }